var map = {
	"./piece1.jpg": 6580,
	"./piece2.jpg": 2446,
	"./piece3.jpg": 6463,
	"./piece4.jpg": 7545,
	"./piece5.jpg": 5734,
	"./piece6.jpg": 1926,
	"./piece7.jpg": 1252,
	"./piece8.jpg": 5312
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8992;